<template>
  <Header headerShadow="header__area header__padding header__padding-2 header__shadow"/>
  <section class="page__title-area pt-90 pb-90">
    <div class="page__title-shape">
      <img class="page-title-shape-5 d-none d-sm-block" src="../assets/img/page-title/page-title-shape-1.png" alt="">
      <img class="page-title-shape-6" src="../assets/img/page-title/page-title-shape-6.png" alt="">
      <img class="page-title-shape-7" src="../assets/img/page-title/page-title-shape-4.png" alt="">
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="course__wrapper">
            <div class="page__title-content mb-25 pt-90">
              <div class="page__title-breadcrumb">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                      <router-link to="/">{{ $t('actions.home') }}</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">{{ $t('event.mainTitle2') }}</li>
                  </ol>
                </nav>
              </div>
              <h5 class="page__title-3" style="font-size: 35px">
                {{
                  getName({
                    nameLt: tadbirlar?.title,
                    nameUz: tadbirlar?.title_uz,
                    nameRu: tadbirlar?.title_ru,
                    nameEn: tadbirlar?.title_en,
                  })
                }}
              </h5>
            </div>

            <div class="course__img w-img mb-30 vector__image">
              <img style="max-height: 600px; object-fit: cover; border-radius: 8px" :src="tadbirlar.image" alt="">
              <div class="vectorLeftSecond">
                <img height="300" src="@/assets/img/vector.png" alt="">
              </div>
            </div>
            <div class="course__tab-content mb-95">
              <div class="tab-content" id="courseTabContent">
                <div class="tab-pane fade show active mb-30" id="description" role="tabpanel" aria-labelledby="description-tab">
                  <div class="course__description">
                    <h3>{{ $t('event.mainTitle3') }}</h3>
                    <p v-html="getCourseTitle(tadbirlar)"></p>
                  </div>
                </div>

                <div class="course__meta-2 d-sm-flex mb-40">
                  <div class="course__share d-flex">
                      <div class="contact__info-icon mr-15">
                        <svg class="map" viewBox="0 0 24 24">
                          <path class="st0" d="M21,10c0,7-9,13-9,13s-9-6-9-13c0-5,4-9,9-9S21,5,21,10z"/>
                          <circle class="st0" cx="12" cy="10" r="3"/>
                        </svg>
                      </div>
                      <div class="contact__info-text">
                        <h4>{{ $t('actions.address') }}</h4>
                        <p>{{tadbirlar?.address}}</p>
                      </div>
                  </div>
                  <div class="course__share d-flex ml-70 mr-70">
                    <div class="contact__info-icon mr-10">
                      <img width="30" src="@/assets/img/calendar.png" alt="">
                    </div>
                    <div class="contact__info-text">
                      <h4>{{ $t('actions.startDate') }}</h4>
                      <p>{{tadbirlar?.start_date + ', ' + tadbirlar?.start_time}}</p>
                    </div>
                  </div>
                  <div class="course__share d-flex">
                    <div class="contact__info-icon mr-10">
                      <img width="30" src="@/assets/img/last.png" alt="">
                    </div>
                    <div class="contact__info-text">
                      <h4>{{ $t('actions.finishDate') }}</h4>
                      <p>{{tadbirlar?.start_date + ', ' + tadbirlar?.end_time}}</p>
                    </div>
                  </div>
                </div>
                <div class="course__meta-2 d-sm-flex mb-30">
                  <div class="course__share">
                    <h5>{{ $t('actions.share') }} :</h5>
                    <ul class="d-flex align-items-start">
                      <li @click="sendToTelegramLink()"><a href="#" class="tw"><i class="fab fa-telegram"></i></a></li>
                      <li @click="copyLink()"><span class="copyLinkk">
                        <img class="blueCopy" width="13" src="@/assets/img/copy.png" alt="">
                        <img class="whiteCopy" width="13" src="@/assets/img/copy1.png" alt="">
                      </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- course side bar start -->
        <!--       <CourseSidebar :course-data="course"/>-->
        <!-- course side bar end -->
      </div>
    </div>
  </section>

  <!-- Footer -->
  <Footer footerPadding="true"/>

</template>

<script>
import Header from '../components/HomeTwo/Header.vue';
import Footer from '../components/Home/Footer.vue';
import CourseItemMixin from '../mixins/courseItemsMixin';
// import CourseSidebar from '../components/CourseDetails/CourseSidebar.vue';
import { mapGetters, mapActions } from 'vuex'
import BlogMixin from '@/mixins/blogMixin';
export default {
  name: "CourseDetailsPage",
  components:{
    Header,
    // CourseSidebar,
    Footer
  },
  mixins: [CourseItemMixin, BlogMixin],
  data() {
    return {
      id: this.$route.params.id,
      course: {},
    }
  },
   created() {
    this.getTadbirlarById(this.id);
  },
  computed:{
    ...mapGetters('tadbirlar', ['tadbirlar']),
  },
  methods: {
    ...mapActions('tadbirlar', ['getTadbirlarById']),

    getCourseTitle(course) {
      const shortName = this.getName({
        nameUz: course?.goal_uz,
        nameLt: course?.goal,
        nameRu: course?.goal_ru,
        nameEn: course?.goal_en,
      });
      return `<p>${shortName}</p>`;
    },
    sendToTelegramLink(){
      window.open('https://t.me/share/url?url='+`https://malaka-oshirish-institut.netlify.app/event-details/${this.id}`, '_blank')
    },
    async copyLink(){
      let data = `https://malaka-oshirish-institut.netlify.app/event-details/${this.id}`
      await navigator.clipboard.writeText(data)
    }
  },
 
};
</script>
<style lang="scss" scoped>

.vector__image {
  position: relative;
  z-index: 1;
}

.vectorLeftSecond {
  position: absolute;
  right: -70px;
  top: -50px;
  z-index: -99;
}
.copyLinkk{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  line-height: 44px;
  text-align: center;
  font-size: 13px;
  background: #ebf6fe;
  border-radius: 4px;
}

.blueCopy{
  display: flex;
}

.whiteCopy{
  display: none;
}
.copyLinkk:hover{
  background: #03a9f4;

}

.copyLinkk:hover .blueCopy{
  display: none;
}
.copyLinkk:hover .whiteCopy{
  display: flex;
}
</style>